export default "__VITE_ASSET__qTvRzMvM__"